import { render, staticRenderFns } from "./CreateDoc.vue?vue&type=template&id=c11b17f0&scoped=true&"
import script from "./CreateDoc.vue?vue&type=script&lang=js&"
export * from "./CreateDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11b17f0",
  null
  
)

export default component.exports